/* eslint-disable no-undef */
import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Badge } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { fetchWrapper } from '../../../../../../../../_helpers/fetchWrapper';
import { clearTable, handleTableData } from '../../../../../../../../Redux/slices/table';
import ParticipantApprovalTable from '../../../tables/ParticipantApprovalTable';
import UserImage from '../../../../../../../../Components/UserImage';
import ToolTip from '../../../../../../../../Components/ToolTip';
import { Link } from 'react-router-dom';
import { toNepaliNumber } from '../../../../../../../../_helpers/_methods';

function ParticipantApprovalTab({ id }) {
  const dispatch = useDispatch();
  const intl = useIntl();
  const local = useSelector((state) => state.local.local);
  const results = useSelector((state) => state.table.results);
  const SelectColumnFilter = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = useMemo(() => {
      const options = new Set();
      preFilteredRows.forEach((row) => {
        options.add(row.values[id]);
      });
      return [...options.values()];
    }, [id, preFilteredRows]);

    // Render a multi-select box
    return (
      <select
        value={filterValue}
        onChange={(e) => {
          setFilter(e.target.value || undefined);
        }}>
        <FormattedMessage id="tableSelect.all">
          {(label) => <option value="">{label[0]}</option>}
        </FormattedMessage>
        {options.map((option, i) => (
          <option key={i} value={option}>
            {option}
          </option>
        ))}
      </select>
    );
  };

  const dataFetcher = ({ index }) => {
    dispatch(
      handleTableData({
        url: `/event/${id}/participants/`,
        index: index,
        params: '&selected=false'
      })
    );
  };
  useEffect(() => {
    return () => {
      dispatch(clearTable());
    };
  }, []);
  const columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="sn" />,
        accessor: 'serial_number',
        disableFilters: true,
        width: '40px'
      },
      {
        Header: <FormattedMessage id="event.userFullName" />,
        accessor: 'fullname',
        Cell: ({ row: { original }, cell: { value } }) => {
          return (
            <Link
              to={`/admin/users/trainees/profile/${original.id}`}
              className="d-flex align-items-center ">
              <div className="me-1 position-relative">
                <UserImage avatar={original.image} userName={value} userId={String(original.id)} />
                <span className="avatar-profile-iscomplete-badge">
                  {original.warnings && (
                    <ToolTip
                      warnings={original.warnings}
                      isComplete={original.is_profile_updated}
                    />
                  )}
                </span>
              </div>
              <span className="d-block">
                {value} <br />
                <small>{original.office_name && original.office_name}</small>
              </span>
              {original.suspended && <Badge bg="danger">Suspended</Badge>}
            </Link>
          );
        },
        width: '170px'
      },
      {
        Header: <FormattedMessage id="event.userPhone" />,
        accessor: 'mobile_number',
        width: '100px'
      },
      {
        Header: <FormattedMessage id="event.userAddress" />,
        accessor: 'address',
        width: '170px'
      },
      {
        Header: <FormattedMessage id="event.gender" />,
        accessor: 'gender',
        Filter: SelectColumnFilter,
        filter: 'equals',
        width: '50px'
      },
      {
        Header: <FormattedMessage id="event.ethnicity" />,
        accessor: 'ethnicity',
        Cell: ({ cell: { value } }) => {
          return <span>{value?.title}</span>;
        },
        width: '120px'
      },
      {
        Header: <FormattedMessage id="event.participantType" />,
        accessor: 'participant_type',
        width: '100px'
      },
      {
        Header: <FormattedMessage id="event.officeName" />,
        accessor: 'office_name'
      }
    ],
    []
  );
  const data = useMemo(() => {
    if (!results) return [];

    let count = 1;
    return results
      .filter((result) => result?.is_selected === false)
      .map((result) => {
        return {
          serial_number: local === 'ne' ? toNepaliNumber(count++) : count++,
          fullname: result.fullname,
          gender: intl.formatMessage({ id: result.gender || 'p' }),
          mobile_number: result.phone ? result.phone : 'not availiable',
          address: result.address,
          ethnicity: result.ethenicity,
          participant_type: result.employee_type_title,
          office_name: result.office_name,
          id: result.id,
          is_profile_updated: result.is_profile_updated,
          warnings: result.warnings,
          image: result.image ? process.env.REACT_APP_BASE_URL + result.image : ''
        };
      });
  }, [results]);

  const handleParticipantApproval = async (participantId) => {
    await fetchWrapper.post(`/event/${id}/approve-participants/`, {
      participants: [participantId]
    });
    dataFetcher({});
  };
  const handleParticipantDisapproval = async (participantId) => {
    await fetchWrapper.post(`/event/${id}/unapprove-participants/`, {
      participants: [participantId]
    });
    dataFetcher({});
  };

  return (
    <ParticipantApprovalTable
      data={data}
      columns={columns}
      dataFetcher={dataFetcher}
      handleApprove={handleParticipantApproval}
      handleDisapprove={handleParticipantDisapproval}
    />
  );
}

export default ParticipantApprovalTab;
